//NOTE: THE BOOLEAN PARAM IS TO PREVENT SAVING THE DEVICEID IN LOCALSTORAGE WHEN THE CREATOR REGISTER
export async function getDeviceInfo() {
  const ua = navigator.userAgent;
  
  // Fetch IP address
  let ipAddress = "";  
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    ipAddress = data.ip;
  } catch (error) {
    console.error("Failed to fetch IP address:", error);
  }

  return {
    userAgent: ua,
    platform: navigator.platform,
    language: navigator.language,
    browser: getBrowserName(ua),
    os: getOSName(ua),
    ipAddress,
  };
}

function getBrowserName(ua: string) {
  if (ua.includes("Chrome")) return "Chrome";
  if (ua.includes("Firefox")) return "Firefox";
  if (ua.includes("Safari") && !ua.includes("Chrome")) return "Safari";
  if (ua.includes("Edg")) return "Edge";
  return "Unknown";
}

function getOSName(ua: string) {
  if (ua.includes("Windows")) return "Windows";
  if (ua.includes("Mac OS")) return "MacOS";
  if (ua.includes("Android")) return "Android";
  if (ua.includes("iPhone") || ua.includes("iPad")) return "iOS";
  return "Unknown";
}
